// Renders the hex lattice edges.
//
// The grid is static: drawn once into a Graphics, then cloned into a 3×3
// tiling (period vectors U, V) so the torus seam is never visible while the
// camera follows the player.

import { Graphics, type Container } from 'pixi.js';
import type { HexGrid } from '@evox/shared';
import { edgeEndpoints, worldPeriods } from './geometry.js';
import { theme } from './theme.js';

let drawnFor: HexGrid | null = null;

export function drawGrid(layer: Container, grid: HexGrid): void {
  if (drawnFor === grid) return; // already drawn; grid is static
  drawnFor = grid;
  layer.removeChildren().forEach((c) => c.destroy());

  const proto = new Graphics();
  for (const edge of grid.edges) {
    const { from, to } = edgeEndpoints(grid, edge);
    proto.moveTo(from.x, from.y);
    proto.lineTo(to.x, to.y);
  }
  proto.stroke({ width: 1.4, color: theme.gridLine, alpha: theme.gridLineAlpha });

  const { u, v } = worldPeriods(grid.dims);
  for (let i = -1; i <= 1; i++) {
    for (let j = -1; j <= 1; j++) {
      const tile = i === 0 && j === 0 ? proto : proto.clone();
      tile.position.set(i * u.x + j * v.x, i * u.y + j * v.y);
      layer.addChild(tile);
    }
  }
}
